//////////////////
// IMPORTS
//////////////////
// schema
// libraries
import React from "react";
// attendees-pain
import { AttendeesPains } from "@clockwise/web-commons/src/components/attendees-pains/";
import { IProps, IState } from "./AttendeesPainsRendererTypes";
// util
import { getAttendeesPainText } from "@clockwise/client-commons/src/util/scheduling-slot";

//////////////////
// COMPONENT
//////////////////
export class AttendeesPainsRenderer extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { schedulingSlot, persons } = this.props;

    // default true
    const renderUnavailableAttendees =
      this.props.renderUnavailableAttendees === undefined ||
      this.props.renderUnavailableAttendees === true;

    const pains =
      schedulingSlot && persons
        ? getAttendeesPainText(schedulingSlot, persons, renderUnavailableAttendees)
        : [];

    return <AttendeesPains pains={pains} />;
  }
}
